import Routine, { RUN } from "+/Engine/Routine";
import DataTypes from "+/Engine/Helpers/DataTypes";

export default class UpdateEntity extends Routine {
  assertValidParams(params) {
    DataTypes.assertObjectKeyExistsOfType("entityType", params, DataTypes.assertString);
    DataTypes.assertObjectKeyExistsOfType("entityPk", params, DataTypes.assertObject);
    DataTypes.assertObjectKeyExistsOfType("fields", params, DataTypes.assertObject);
  }

  [RUN](params) {
    const { entityType, fields } = params;
    const pkFields = this.app.getEntityPrimaryKeyFields(entityType);
    const entityPk = {};
    pkFields.forEach(field => {
      entityPk[field] = params.entityPk[field];
    });

    const existingFields = this.app.getEntity(entityType, entityPk).getBasicFieldData();
    this.app.upsertEntity(entityType, entityPk, { ...existingFields, ...fields }, false, "update entity routine");
    // Return plain basic field data rather than the Entity instance. Entity instances expose
    // manyEntities fields as enumerable getters that read from FeedStore, so JSON.stringify
    // walks them and recursively serializes every loaded feed item — which explodes the
    // transaction payload when we stash routine results into `this.#params` and POST the
    // whole thing to /transactions. The server only needs the basic field data as the
    // routine's client-side result (it's used as client_entity for temp-pk reconciliation).
    return this.app.getEntity(entityType, entityPk).getBasicFieldData();
  }
}

Routine.register("UpdateEntity", UpdateEntity);
